export interface Result<T> {
  data: T[]
  total: number
  page: number
  size: number
}

export const ResultInitState: Result<any> = {
  data: [],
  total: 0,
  page: 0,
  size: 0
}
